import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { simpleCopy } from '@/utils/deepCopy';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { IParentBusiness } from '../domains/entities/Business';
import { RecommendOrderFactory } from '../domains/factories/RecommendOrderFactory';

/**
 * 在庫管理ページ向けに推奨発注を取得する
 */
export class GetRecommendedOrderForInventoryControlUseCase {
  /**
   * 受け取ったシミュレーション結果をもとに、推奨発注を作成する
   * @param businesses - 取引情報
   * @returns 取引情報
   */
  static async Execute(businesses: IParentBusiness[]): Promise<INetworkResult<IParentBusiness[], Error>> {
    const output: IParentBusiness[] = [];
    businesses.forEach((business) => {
      const recommendEstimateTime: Date | undefined = business.recommendEstimateTime;
      const recommendArrivalValue: number | undefined = business.recommendArrivalValue;

      // どっちもある場合のみ推奨発注を追加
      if (recommendEstimateTime && recommendArrivalValue) {
        const updatedBiz = simpleCopy(business);
        updatedBiz.recommend.push(
          RecommendOrderFactory.create({
            isFixOrdered: false,
            crossDate: DateService.convertDateToIDate(recommendEstimateTime),
            amount: recommendArrivalValue,
          })
        );
        output.push(updatedBiz);
      } else {
        output.push(business);
      }
    });
    return {
      status: {
        type: 'success',
        data: output,
      },
    };
  }
}
